import { useEffect, useState } from 'react';

import { getReferenceData, getConsignees, getConsignors } from '../../../api/util';

const useReferenceData = (companyId) => {
  const [referenceData, setReferenceData] = useState({});
  const [consignees, setconsignees] = useState([]);
  const [consignors, setConsignors] = useState([]);
  const refDatas = [
    'modeOfTransport',
    'packageTypes',
    'ports?entryport=true',
    'ports?entryport=false',
    'countryOfOrigin',
    'getDocumentType',
    'charges',
    'unDangerousGoods',
  ];

  useEffect(() => {
    const fetchData = async () => {
      const consignors = await getConsignors(companyId);
      const consignees = await getConsignees(companyId);
      setconsignees(consignees);
      setConsignors(consignors);

      setReferenceData((prev) => ({
        ...prev,
        consignees,
        consignors,
      }));
      //update referenceData, adding consignors and consignees
    };

    // ensuring data is only fetched once rest of referenceData has initialized
    if (companyId && Object.keys(referenceData).length && !referenceData.consignees && !referenceData.consignors) {
      fetchData();
    }
  }, [companyId, referenceData]);

  const retrieveReferenceData = async () => {
    const refData = {};
    for (const element of refDatas) {
      const data = await getReferenceData(element);
      if (
        element !== 'countryOfOrigin' &&
        !element.includes('ports') &&
        element !== 'packageTypes' &&
        element !== 'unDangerousGoods'
      ) {
        const mappedData = data.map((d) => {
          const keys = Object.keys(d);
          return { key: d[keys[0]], value: d[keys[1]] };
        });
        refData[element] = mappedData;
      } else if (element === 'packageTypes') {
        const mappedData = data.map((d) => {
          return { key: d.id, value: d.data, piecesRequired: d.piecesRequired };
        });
        refData['packageTypes'] = mappedData;
      } else if (element.includes('ports')) {
        const mappedData = data.map((d) => {
          const keys = Object.keys(d);
          return { key: d[keys[0]], value: d[keys[1]] };
        });
        if (element.includes('true')) refData['entryPorts'] = mappedData;
        else refData['exitPorts'] = mappedData;
      } else if (element === 'countryOfOrigin') {
        const mappedDataId = data.map((d) => {
          return { key: d.id, value: d.countryName };
        });
        refData['countryOfOriginId'] = mappedDataId;
        const mappedDataCC = data.map((d) => {
          return { key: d.countryCode, value: d.countryName };
        });
        refData['countryOfOriginCC'] = mappedDataCC;
        const mappedDataMap = data.map((d) => {
          return { key: d.id, value: d.countryCode };
        });
        refData['countryOfOriginMap'] = mappedDataMap;
      } else if (element === 'unDangerousGoods') {
        const mappedData = data.map((d) => {
          const formattedCode = d.code.toString().padStart(4, '0'); // format as 4 digits with leading zeros
          return {
            key: formattedCode,
            value: `${formattedCode} - ${d.description}`,
          };
        });
        refData['unDangerousGoods'] = mappedData;
      }
    }
    refData['packagesWithPiecesRequired'] = refData.packageTypes.filter((p) => p.piecesRequired).map((p) => p.key);
    //update referenceData with the new data, but keep the old data as well
    setReferenceData((prev) => ({ ...prev, ...refData }));
  };

  useEffect(() => {
    retrieveReferenceData();
  }, []);

  const refreshNeenors = async () => {
    setReferenceData((prev) => ({
      ...prev,
      consignees,
      consignors,
    }));
  };

  return { referenceData, refreshNeenors };
};

export default useReferenceData;
